import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Paragraph } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphTimeline as Type } from '../../../types/uncinc_profile/paragraphs';

import useTimelineProgress from './useTimelineProgress';

import './style.scss';

interface ParagraphTimelineProps {
  entity: ImmutableEntity<Type>;
}

const ParagraphTimeline: React.FC<ParagraphTimelineProps> = ({
  entity,
}) => {
  const { t } = useTranslation();
  const { listRef, lineRef } = useTimelineProgress();

  const paragraph = entity.toJS();
  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const timelineItems = paragraph.field_paragraphs;
  const subHeading = t('paragraph.timeline.overview_subheading');

  return (
    <div className="Paragraph ParagraphTimeline">
      <Container>
        <div className="row">

          <div className="ParagraphTimeline__introwrapper col-12">
            <div className="ParagraphTimeline__intro">
              {
                title
                  ? <h2>{title}</h2>
                  : <h2 className="visually-hidden">{subHeading}</h2>
              }
              {body && <WysiwygField html={body} />}
            </div>
          </div>

          <div className="ParagraphTimeline__content col-12 col-lg-8 offset-lg-2">
            <div className="ParagraphTimeline__row">
              <div
                className="ParagraphTimeline__line"
                ref={lineRef}
              />
              <ol
                ref={listRef}
                className="ParagraphTimeline__subparagraphs"
              >
                {timelineItems.map((timelineItem) => {
                  const id = timelineItem.target_id;

                  return (
                    <Paragraph
                      key={`paragraph:${id}`}
                      id={id}
                      entity={Immutable.fromJS(timelineItem.entity)}
                    />
                  );
                })}
              </ol>
            </div>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default ParagraphTimeline;
